module.exports = __webpack_public_path__ + "img/aa4c287.jpg";